import { cn } from "@/lib/utils";

/*
 * Lezo logo, drawn on fixed-width terminal cells (44 units): a monoline "lezo"
 * whose "l" foot makes a draughtsman's square, closed by a block cursor in
 * the signal colour. Sources and usage: docs/brand/logo.html, public/brand/.
 */
const L = "M4 0V60H34";
const E = "M48 45H74V38Q74 28 64 28H58Q48 28 48 38V50Q48 60 58 60H78";
const Z = "M88 28H117L93 60H122";
const O =
	"M146 28H152Q162 28 162 38V50Q162 60 152 60H146Q136 60 136 50V38Q136 28 146 28Z";

/**
 * Wordmark in `currentColor` with the cursor in `signal`. `animated` types it
 * out once on first paint (CSS only, so it plays before hydration).
 */
export function LezoWordmark({
	animated = false,
	title = "Lezo",
	className,
}: {
	animated?: boolean;
	title?: string;
	className?: string;
}) {
	return (
		<svg
			viewBox="0 0 200 64"
			role="img"
			aria-label={title}
			className={cn(
				"h-6 w-auto shrink-0",
				animated && "lz-animated",
				className,
			)}
		>
			<g fill="none" stroke="currentColor" strokeWidth="8">
				<path className="lz-l" d={L} strokeLinejoin="miter" />
				<path className="lz-e" d={E} strokeLinejoin="round" />
				<path className="lz-z" d={Z} strokeLinejoin="round" />
				<path className="lz-o" d={O} strokeLinejoin="round" />
			</g>
			<rect
				className="lz-cursor fill-signal"
				x="176"
				y="24"
				width="24"
				height="40"
			/>
		</svg>
	);
}
